import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { MdClose } from "react-icons/md";

const PaidDetailsModal = ({ open, onClose, details }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxWidth: "90%",
          boxShadow: 24,
          maxHeight: "60vh",
          borderRadius: 2,
          padding: "20px",
        }}
        className="bg-white dark:bg-gray-700 dark:text-white"
      >
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <MdClose size={24} />
        </IconButton>
        <Typography variant="h6" gutterBottom>
          Paid Details
        </Typography>
        <p className="mb-3" variant="body1">
          <strong>Amount:</strong> {details?.trip_advance_paid || "- dfdgdfgf"}
        </p>
        <p className="mb-3" variant="body1">
          <strong>Paid Date:</strong> {details?.paid_date || "-"}
        </p>
        <p className="mb-3" variant="body1">
          <strong>UTR:</strong> {details?.utr || "-"}
        </p>
      </Box>
    </Modal>
  );
};

export default PaidDetailsModal;
